(() => {
  const name = 'megamenu';

  App.common = App.common || {};

  App.common[name] = (() => {
    const $megaMenuWrapper = $('#megamenu-wrap');
    const HIDE_DELAY = 500;
    const menuTemplates = {
      lenses: JST['mega-menu-lenses'],
      extraslo: JST['mega-menu-extras'],
    };
    const mobileMenuTemplates = {
      lenses: JST['mega-menu-lenses-mobile'],
      extraslo: JST['mega-menu-extras-mobile'],
    };

    const checkHoverCaller = function (context) {
      const hoverCaller = $(context).data('hoverCaller');
      if (hoverCaller) {
        hoverCaller.removeClass('hover');
      }
    };

    function HoverTimeout() {
      this.timeout = 0;
      this.setMyTimeout = function setHoverTimeout(element, time, callback) {
        const delay = time || HIDE_DELAY;
        this.timeout = setTimeout(() => {
          if (typeof callback === 'function') {
            callback();
            return;
          }
          const $element = (typeof element === 'string') ? $(`.${element}`) : $(element);
          $element.addClass('hide');
          checkHoverCaller($element);
        }, delay);
      };
      this.clearMyTimeout = function clearHoverTimeout() {
        clearTimeout(this.timeout);
      };
    }

    const loadMegamenu = function (menuLayout) {
      const $blocks = menuLayout === 'desktop' ? $megaMenuWrapper.find('.megamenu-content') : $('.link-list__item');
      const menuStructure = menuLayout === 'desktop' ? menuTemplates : mobileMenuTemplates;

      const loadMenuBlock = function () {
        const $currentMenu = $(this);
        const menuType = $currentMenu.data('type');
        $currentMenu.html(menuStructure[menuType](window.App.settings.megamenu[menuType]));
      };

      $blocks.each((index, element) => {
        loadMenuBlock.call(element, $(element).data('menu'));
      });
    };

    const setEventListeners = function () {
      const expandMegaMenuTimeout = new HoverTimeout();
      const $currentMegaMenu = $('.megamenu');
      let gThisTimeout = null; // Is undefined instead of null, because it's what clearTimeout "returns"
      let $gCurrentMegaMenu = null;

      function hideMegaMenu() {
        $('.js-has-megamenu.expanded').removeClass('expanded');
        $currentMegaMenu.addClass('hide').removeClass('expanded');
        $megaMenuWrapper.removeClass('expanded');
        // eslint-disable-next-line no-use-before-define
        document.removeEventListener('click', clickOutsideMegamenuHandler);
      }

      function clickOutsideMegamenuHandler(e) {
        const $target = $(e.target);
        if (!$target.closest($megaMenuWrapper).length) {
          hideMegaMenu();
        }
      }

      /**
       *
       * @param timeToTimeout
       */
      const handleMegaMenu = function (timeToTimeout) {
        if (timeToTimeout === true) {
          gThisTimeout = clearTimeout(gThisTimeout); // Cancel any ongoing timeout
          hideMegaMenu();
        } else {
          const delay = timeToTimeout || HIDE_DELAY;
          if (typeof gThisTimeout === 'undefined') {
            gThisTimeout = setTimeout(() => {
              // Only clear the references when the actual timeout occurs.
              $gCurrentMegaMenu = null;
              hideMegaMenu();
            }, delay);
          } else {
            gThisTimeout = clearTimeout(gThisTimeout);
          }
        }
      };

      $('.js-has-megamenu')
        .on('mouseenter', function onMegaMenuMouseEnter() {
          const $this = $(this);
          const executeOpen = function () {
            function expandMegaMenu() {
              $gCurrentMegaMenu = $(`.${$this.data('megamenu')}`);
              handleMegaMenu(true);
              $this.addClass('expanded');
              $megaMenuWrapper.addClass('expanded');
              $gCurrentMegaMenu.removeClass('hide');

              App.eventBus.trigger('megamenu:opened');
              // Add event listener with delay to avoid race condition
              setTimeout(() => {
                document.addEventListener('click', clickOutsideMegamenuHandler);
              }, 100);
            }

            expandMegaMenuTimeout.setMyTimeout(this, 300, expandMegaMenu);
          };

          executeOpen();
        })
        .on('mouseleave', () => {
          expandMegaMenuTimeout.clearMyTimeout();
          if ($gCurrentMegaMenu !== null && !$gCurrentMegaMenu.is(':hover')) {
            gThisTimeout = clearTimeout(gThisTimeout);
            handleMegaMenu();
          }
        })
        .on('touchend', function onMegaMenuTouchEnd() {
          const $this = $(this);
          const dataOpened = $this.data('opened');
          if (dataOpened) {
            if (dataOpened.target && dataOpened.target === $this.data('megamenu')) {
              window.location = $this.find('a').attr('href');
            } else {
              $this.data('opened', false);
              $this.trigger('mouseleave');
            }
          } else {
            $('.js-has-megamenu').data('opened', false);
            $this.data('opened', {
              target: $this.data('megamenu'),
            });
            $this.trigger('mouseenter');
          }
        })
        .find('a')
        .on('touchend', (e) => {
          e.preventDefault();
        });

      App.eventBus
        .on('page:scrolled', hideMegaMenu);

      $currentMegaMenu
        .on('mouseenter', '.megamenu__content', function onMegaMenuMouseEnter() {
          gThisTimeout = clearTimeout(gThisTimeout);

          // The below is needed for FireFox only
          // Otherwise the megamenu is hidden - I'm guessing because the check for :hover happens before it is triggered.
          $(this).closest('.megamenu').removeClass('hide');
          $megaMenuWrapper.addClass('expanded');
        })
        .on('mouseleave', '.megamenu__content', function onMegaMenuMouseLeave() {
          const $thisParent = $(`[data-megamenu="js-${$(this).closest('.megamenu').attr('id')}"]`);

          if (!$thisParent.is(':hover')) {
            handleMegaMenu(); // Hide everything with delay
          }
        })
        .on('click', '.megamenu-close', () => {
          handleMegaMenu(true);
          $('.js-has-megamenu').data('opened', false);
        });
    };

    const init = function () {
      setEventListeners();
      loadMegamenu('desktop');
      loadMegamenu('mobile');
    };

    return {
      init,
    };
  })();
})();
